import { get } from 'lodash'

export const openModalsIdsSelector = state => get(state, 'modal.data.openModalIds', [])
export const openModalsCountSelector = state => get(state, 'state.modal.data.openModalIds.length', 0)
